<template>
  
  <div :class="$style.container">
    <MessageCreated :channel="privateChannel" />
    <div :class="$style.chatContainer">
      <h3 v-if="hasStreamEnded">
        Live stream has ended
      </h3>
      <ChatWindow :activity="activity" :focus="true" :request-url="requestUrl" :read-only="hasStreamEnded"/>
    </div>
  </div>
</template>

<script>
import ChatWindow from '@/components/shared/chat-window/chat-window'
import MessageCreated from '@/components/shared/message-created/message-created'
import { jiminnyHost } from '@/helpers/region'

let privateChannelName = ''

export default {
  components: {
    ChatWindow,
    MessageCreated
  },
  props: [
    'activity'
  ],
  data () {
    return {
      privateChannel: null,
      hasStreamEnded: false
    }
  },
  created () {
    this.registerPusher()
  },
  computed: {
    requestUrl () {
      return `${jiminnyHost()}/api/v1/activity/${this.activity.id}/message`
    }
  },
  methods: {
    registerPusher () {
      privateChannelName = `private-activity.${this.activity.id}`

      this.privateChannel = this.$pusher.subscribe(privateChannelName)

      this.privateChannel.bind('pusher:subscription_succeeded', () => (this.privateChannelSubscribed = true))

      this.subscribeEndOfConference()
    },
    subscribeEndOfConference () {
      this.privateChannel.bind('stream-ended', () => {
        this.hasStreamEnded = true
      })
    }
  }
}
</script>

<style module lang="less" src="./LiveCoach.less"></style>



// WEBPACK FOOTER //
// LiveCoach.vue?3518d4bc